<div [@loadedFadeAnimation]="'visible'" class="container">
  <div class="row">
    <div class="col-12">
      <h1>Test de cita</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <input type="text" class="form-control" [(ngModel)]="code" placeholder="Código del distribuidor" />
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button class="btn btn-primary" (click)="testCita()">Test de cita</button>
    </div>
  </div>
</div>
